import { render, staticRenderFns } from "./matter_material.vue?vue&type=template&id=3af167ce&scoped=true&"
import script from "./matter_material.vue?vue&type=script&lang=js&"
export * from "./matter_material.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af167ce",
  null
  
)

export default component.exports